

const UniversityDeanDashboard = () => {
  return (
    <div>
      Dashboard
    </div>
  )
}

export default UniversityDeanDashboard
